<ng-to-track-header
  *ngIf="(store$ | async) as store"
  [selectedFromTrack]="store.trackMoveState.selectedFromTrack"
  [selectedToTrack]="store.trackMoveState.selectedToTrack"
  [fromTrackData]="store.trackMoveState.fromTrackData"
  [toTrackData]="store.trackMoveState.toTrackData"
  [customerSelected]="customerSelected"
  [toTrackGrid]="toTrackGrid"
  [fromTrackGrid]="fromTrackGrid"
  (adjustTrack)="dispatch($event)"
></ng-to-track-header>
